module.exports = __webpack_public_path__ + "media/src/assets/wave-9bff99604da533a9e8cb727ae9765010.png";